import { render, staticRenderFns } from "./CardMultitarefas.vue?vue&type=template&id=787ca984"
import script from "./CardMultitarefas.vue?vue&type=script&lang=js"
export * from "./CardMultitarefas.vue?vue&type=script&lang=js"
import style0 from "./CardMultitarefas.vue?vue&type=style&index=0&id=787ca984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports